module.exports = __webpack_public_path__ + "img/puberty-decal-05.b7b0f28f.png";